import anime from 'animejs'

// Disable scroll on menu show

const toggle_scroll = () => {
  if (burger.checked) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'visible'
  }
}

const burger = document.querySelector('#burger-menu')
burger.addEventListener('click', toggle_scroll)

const nav_links = document.querySelectorAll('.nav__link')
nav_links.forEach((item) => {
  item.addEventListener('click', () => {
    if (burger.checked) {
      burger.checked = !burger.checked
      toggle_scroll()
    }
  })
})

// To top button

const toTopButton = document.querySelector('.to-top')
toTopButton.addEventListener('click', (event) => {
  window.scrollTo(0, 0)
})

// Animations

anime({
  targets: '.header__logo',
  rotate: [180, 360],
  scale: [1.5, 1],
  duration: 3000,
})

const listItems = document.querySelectorAll('.nav-desktop__list-item')
listItems.forEach((listItem) => (listItem.style.transform = 'translateY(-100%)'))
anime({
  targets: listItems,
  translateY: 0,
  duration: 1000,
  delay: anime.stagger(100),
  easing: 'easeInOutQuad',
})

// Disable scroll text and icon header on scroll

const headerScroll = document.querySelector('.header__scroll')
window.addEventListener('scroll', e => {
  if (window.pageYOffset > 10) {
    headerScroll.style.opacity = 0;
  } else {
    headerScroll.style.opacity = 1;
  }
})

